export const REVIEWS = [
  {
    name: "Milica Tešić",
    meta: "Local Guide · 237 recenzija",
    stars: 5,
    text: "Stvarno jeftina, a neverovatna — i sveže spremljena — hrana.",
  },
  {
    name: "Ђоле",
    meta: "Local Guide · 13 recenzija",
    stars: 5,
    text: "Roštilj je stvarno dobar, svež, ukusan... 18 priloga — to nigde do sada nismo videli.",
  },
  {
    name: "Marko 4 You",
    meta: "Local Guide · 52 recenzije",
    stars: 5,
    text: "Odlično mesto! Brza i ukusna hrana. Najposećenije mesto posle izlaska — dostava za 30–40 minuta širom Kragujevca. Pristupačne cene!",
  },
  {
    name: "Nikola Sokolović",
    meta: "Local Guide · 268 recenzija",
    stars: 5,
    text: "Kakav fantastičan dijamant, sakriven u Kragujevcu. Odlično meso, brza usluga! Sigurno se vraćamo.",
  },
  {
    name: "Стефани Славчева",
    meta: "Local Guide · 1.907 recenzija",
    stars: 5,
    text: "Odlično mesto za brz i ukusan obrok u Kragujevcu. Hrana je sveža i veoma ukusna — oseti se već pri prvom zalogaju.",
  },
  {
    name: "Keith Tpage",
    meta: "Local Guide · 1.857 recenzija",
    stars: 5,
    text: "Sjajno iskustvo. Hrana je izuzetno ukusna i pravo je zadovoljstvo pronaći ovako nešto u gradu.",
  },
  {
    name: "Fikus Freeski",
    meta: "Local Guide · 33 recenzije",
    stars: 5,
    text: "Najbolji burgeri u gradu.",
  },
  {
    name: "Dušan Gojković",
    meta: "Local Guide · 14 recenzija",
    stars: 5,
    text: "Najbolji fast food u gradu. Kvalitet je odličan.",
  },
  {
    name: "Миона Гајовић",
    meta: "Local Guide · 13 recenzija",
    stars: 5,
    text: "Najbolji burgeri u gradu. Cene su pristupačne, priloga ima u izobilju. Sve pohvale.",
  },
];
